import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { usePet } from "@/hooks/usePet";
import { LandingNavbar } from "@/components/landing/LandingNavbar";
import { HeroSection } from "@/components/landing/HeroSection";
import { WaveDivider } from "@/components/landing/ui/WaveDivider";
import { ModesSection } from "@/components/landing/ModesSection";
import { FeaturesSection } from "@/components/landing/FeaturesSection";
import { HowItWorksSection } from "@/components/landing/HowItWorksSection";
import { ChatDemoSection } from "@/components/landing/ChatDemoSection";
import { TestimonialsSection } from "@/components/landing/TestimonialsSection";
import { FAQSection } from "@/components/landing/FAQSection";
import { CTASection } from "@/components/landing/CTASection";
import { LandingFooter } from "@/components/landing/LandingFooter";
import { ScrollToTopButton } from "@/components/ScrollToTopButton";
import { useHreflang } from "@/i18n/useHreflang";
import { useLocalizedMeta } from "@/i18n/useLocalizedMeta";

const Landing: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { pet } = usePet();

  useHreflang();
  useLocalizedMeta();

  return (
    <div className="min-h-screen overflow-x-hidden">
      <LandingNavbar />
      <HeroSection />
      <WaveDivider />
      <ModesSection />
      <WaveDivider color="hsl(25 60% 90% / 0.4)" />
      <FeaturesSection />
      <WaveDivider flip />
      <HowItWorksSection />
      <WaveDivider color="hsl(30 50% 92% / 0.5)" />
      <ChatDemoSection />
      <WaveDivider flip />
      <TestimonialsSection />
      <WaveDivider color="hsl(35 60% 90% / 0.4)" />
      <FAQSection />
      <CTASection />
      <LandingFooter />
      <ScrollToTopButton />
    </div>
  );
};

export default Landing;
